import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISVerticalStepperComponent } from './is-vertical-stepper.component';
import { MatIconModule } from '@angular/material/icon';
import { OverflowDirective } from './overflow.directive';

const materialModules = [
    MatIconModule
];

@NgModule({
    declarations: [ISVerticalStepperComponent, OverflowDirective],
    imports: [
        CommonModule,
        ...materialModules    
    ],
    exports: [ISVerticalStepperComponent],
    providers: [],
})
export class ISVerticalStepperModule {}